import { render, staticRenderFns } from "./JVTable.vue?vue&type=template&id=63b3cec6&scoped=true&"
import script from "./JVTable.vue?vue&type=script&lang=js&"
export * from "./JVTable.vue?vue&type=script&lang=js&"
import style0 from "./JVTable.vue?vue&type=style&index=0&id=63b3cec6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b3cec6",
  null
  
)

export default component.exports